module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"propPages\" class=\"prop-detail\"></div>\r\n<div id=\"propSections\" class=\"prop-detail\"></div>\r\n<div id=\"propAppendix\" class=\"style-background prop-detail\"></div>\r\n<div id=\"propViewing\" class=\"style-viewing prop-detail\"></div>\r\n<div id=\"propLocking\" class=\"style-locking prop-detail\"></div>\r\n<div id=\"propLocation\" class=\"style-location prop-detail\"></div>\r\n")
  }
  return __output;

}